import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import addNoDataModule from 'highcharts/modules/no-data-to-display';
import HCMore from "highcharts/highcharts-more";

addNoDataModule(Highcharts);
HCMore(Highcharts);

export default class GradeRangeChart extends Component {
  static propTypes = {
    marketRateChart: PropTypes.object,
    structureList: PropTypes.object,
    getMarketRateChart: PropTypes.func,
    isScenarioChart: PropTypes.bool,
    chartTitle: PropTypes.string,
    marketRateChartHeight: PropTypes.number,
    marketRateChartWidth: PropTypes.number,
    history: PropTypes.object,
    filtersAreOpen: PropTypes.bool,
    isResponsive: PropTypes.bool,
    id: PropTypes.string,
    jobGrade: PropTypes.string,
    recommendGrade: PropTypes.object,
    removeLoadingText: PropTypes.bool
  };

  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    this.resizeChart(nextProps);

    const { marketRateChart, structureList, isScenarioChart, jobGrade, recommendGrade } = this.props;

    if (
      marketRateChart.loaded !== nextProps.marketRateChart.loaded ||
      marketRateChart.loading !== nextProps.marketRateChart.loading ||
      marketRateChart.error !== nextProps.marketRateChart.error
    ) {
      return true;
    }
    if (
      structureList.loaded !== nextProps.structureList.loaded ||
      structureList.loading !== nextProps.structureList.loading ||
      structureList.error !== nextProps.structureList.error
    ) {
      return true;
    }
    if (isScenarioChart !== nextProps.isScenarioChart) {
      return true;
    }

    if (jobGrade !== nextProps.jobGrade || recommendGrade !== nextProps.recommendGrade) {
      return true;
    }
    return false;
  }

  resizeChart(nextProps) {
    if (this.props.filtersAreOpen !== nextProps.filtersAreOpen) {
      const chart = this.marketRangeChart && this.marketRangeChart.getChart();
      if (chart) {
        chart.setSize(nextProps.filtersAreOpen ? 800 : 1100);
      }
    }
  }

  render() {
    let highChartsConfig = undefined;
    if (this.props.marketRateChart && this.props.marketRateChart.highChartsJson) {
      const chartRow = document.getElementById('row--charts');
      let chartRowWidth = document.innerWidth;
      if (chartRow) {
        chartRowWidth = chartRow.clientWidth;
      }
      let chartWidth = chartRowWidth * (2 / 3) - 200;

      if (this.props.marketRateChartWidth) {
        chartWidth = this.props.marketRateChartWidth;
      }

      highChartsConfig = this.props.marketRateChart.highChartsJson;
      //
      highChartsConfig.chart.height = this.props.marketRateChartHeight;

      if (this.props.isResponsive) {
        highChartsConfig.responsive = {
          rules: [{ condition: { maxWidth: chartWidth } }]
        };
      } else {
        highChartsConfig.chart.width = chartWidth;
      }

      highChartsConfig.yAxis.min = 0;
      highChartsConfig.yAxis.labels = {
        enabled: false
      };

      highChartsConfig.tooltip = {
        enabled: false
      };
    }

    const loading = this.props.removeLoadingText ? '' : <p>Loading...</p>;

    return (
      <div>
        <div className="chart__marketRateChartTitle">{this.props.chartTitle}</div>
        {highChartsConfig ? <HighchartsReact config={highChartsConfig} /> : loading }
      </div>
    );
  }
}
